"use strict";
exports.__esModule = true;
exports.useDeepLayoutEffect = exports.useDeepImperativeHandle = exports.useDeepCallback = exports.useDeepMemo = exports.useDeepEffect = void 0;
var react_1 = require("react");
var lodash_1 = require("lodash");
function useDeepCompare(value) {
    var prevValue = react_1.useRef(null);
    var signalRef = react_1.useRef(false);
    if (!lodash_1.isEqual(value, prevValue.current)) {
        prevValue.current = lodash_1.cloneDeep(value);
        signalRef.current = !signalRef.current;
    }
    return [signalRef.current];
}
function useDeepEffect(effect, deps) {
    return react_1.useEffect(effect, useDeepCompare(deps));
}
exports.useDeepEffect = useDeepEffect;
function useDeepMemo(factory, deps) {
    return react_1.useMemo(factory, useDeepCompare(deps));
}
exports.useDeepMemo = useDeepMemo;
function useDeepCallback(callback, deps) {
    return react_1.useCallback(callback, useDeepCompare(deps));
}
exports.useDeepCallback = useDeepCallback;
function useDeepImperativeHandle(ref, init, deps) {
    return react_1.useImperativeHandle(ref, init, useDeepCompare(deps));
}
exports.useDeepImperativeHandle = useDeepImperativeHandle;
function useDeepLayoutEffect(effect, deps) {
    return react_1.useLayoutEffect(effect, useDeepCompare(deps));
}
exports.useDeepLayoutEffect = useDeepLayoutEffect;
